import { createSelector } from 'reselect';

const getAssessmentItemsBranch = (state) => state.assessmentItems;
const mapAssignmentsBranch = (state) =>
  getAssessmentItemsBranch(state).mapAssignmentsStatus;
const downloadCsvBranch = (state) =>
  getAssessmentItemsBranch(state).downloadCsvStatus;
const exportGradesStatusBranch = (state) =>
  getAssessmentItemsBranch(state).exportGradesStatus;
const getFetchGradesStatusBranch = (state) =>
  getAssessmentItemsBranch(state).fetchGradesStatus;

const getAssessmentItemsIds = createSelector(
  getAssessmentItemsBranch,
  ({ ids }) => ids
);

const getAssessmentItemsById = createSelector(
  getAssessmentItemsBranch,
  ({ byId }) => byId
);

export const getAssessmentItems = createSelector(
  getAssessmentItemsIds,
  getAssessmentItemsById,
  (ids = [], byId) => ids.map((id) => byId[id])
);

const getAssessmentItemsStatus = createSelector(
  getAssessmentItemsBranch,
  ({ status }) => status
);

export const getAssessmentItemsIsLoading = createSelector(
  getAssessmentItemsStatus,
  ({ isLoading }) => isLoading
);

export const getAssessmentItemsError = createSelector(
  getAssessmentItemsStatus,
  ({ error }) => error
);

export const mapAssignmentsIsLoading = createSelector(
  mapAssignmentsBranch,
  ({ isLoading }) => isLoading
);

export const mapAssignmentsIsSuccessful = createSelector(
  mapAssignmentsBranch,
  ({ isSuccessful }) => isSuccessful
);

export const mapAssignmentsError = createSelector(
  mapAssignmentsBranch,
  ({ error }) => error && error.message
);

export const getIsGeneratingCsv = createSelector(
  downloadCsvBranch,
  ({ isGeneratingCsv }) => isGeneratingCsv
);

export const getIsInitiatingExport = createSelector(
  exportGradesStatusBranch,
  ({ isInitiatingExport }) => isInitiatingExport
);

export const getIsFetchingGrades = createSelector(
  getFetchGradesStatusBranch,
  ({ isFetching }) => isFetching
);

export const getFetchGradesError = createSelector(
  getFetchGradesStatusBranch,
  ({ error }) => error
);
